exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".badge[data-v-5f7843ab],.small-icon[data-v-5f7843ab]{height:15px;margin-right:3px}.small-icon[data-v-5f7843ab]{cursor:pointer;margin-bottom:-6px}.small-icon-h[data-v-5f7843ab]{margin-right:3px;cursor:pointer;height:25px;margin-bottom:-10px;-webkit-transform:scale(1.1);transform:scale(1.1)}@media print{.hideinprint[data-v-5f7843ab]{display:none!important}}", ""]);

// exports
